import { useContext, useEffect, useState } from 'react';
import { useMe } from 'hooks/useMe';
import { AppContext } from 'shared/AppContext';
import storage from 'shared/storage';

const useAccountSetup = () => {
  const { data: user } = useMe();
  const { dispatch } = useContext(AppContext);

  const [account, setAccount] = useState();
  const [capabilities, setCapabilities] = useState();
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  const findCapabilities = (accountId) => {
    // eslint-disable-next-line no-unused-expressions
    user?.me?.capabilities?.forEach((capability) => {
      if (capability.account_id === accountId) {
        setCapabilities(capability);
        dispatch({
          type: 'SET_CAPABILITIIES',
          capabilities: capability,
        });
      }
    });
  };

  const setAccountId = (accountId) => {
    storage.set('accountId', accountId);
    dispatch({
      type: 'SET_ACCOUNT_ID',
      accountId: accountId,
    });
  };

  const setAccountName = (accountName) =>
    dispatch({
      type: 'SET_ACCOUNT_NAME',
      accountId: accountName,
    });

  const setAccountScanners = (janamScanners) =>
    dispatch({
      type: 'SET_ACCOUNT_SCANNERS',
      janamScanners: janamScanners,
    });

  const setAccountData = (accountData) =>
    dispatch({
      type: 'SET_ACCOUNT_DATA',
      account: accountData,
    });

  const setSelectedAccount = (value) => {
    setAccount(value);
    setAccountId(value.value);
    setAccountName(value.label);
    setAccountScanners(value.janam_scanners);
    setAccountData(value.data);
    findCapabilities(value.value);
  };

  useEffect(() => {
    if (user && user.me) {
      dispatch({
        type: 'SET_ME',
        user: user?.me,
      });

      if (user.me?.role !== 'admin') {
        if (Array.isArray(user?.me?.accounts)) {
          if (user.me.accounts && user.me.accounts.length > 0) {
            setAccount({
              value: user?.me?.accounts[0].id,
              label: user?.me?.accounts[0].business_dba,
              janam_scanners: user?.me?.accounts[0].janam_scanners,
              data: user?.me?.accounts[0],
            });

            const selectedAccount = storage.get('selected_account');

            if (selectedAccount) {
              setSelectedAccount(selectedAccount);
            } else {
              setAccountId(user?.me?.accounts[0].id);
              setAccountName(user?.me?.accounts[0].business_dba);
              setAccountScanners(user?.me?.accounts[0].janam_scanners);
              setAccountData(user?.me?.accounts[0]);
              findCapabilities(user?.me?.accounts[0].id);
            }
          } else {
            setShowPermissionModal(true);
          }
        }
        if (Array.isArray(user?.me?.promoters)) {
          dispatch({
            type: 'SET_PROMOTERS',
            promoters: user?.me?.promoters,
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const accountOptions = user?.me?.accounts?.map((item) => ({
    value: item.id,
    label: item.business_dba,
    janam_scanners: item.janam_scanners,
    data: item,
  }));

  return {
    user,
    account,
    capabilities,
    accountOptions,
    showPermissionModal,
    setShowPermissionModal,
    setSelectedAccount,
  };
};

export default useAccountSetup;
